var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18C8.20625 18 10 16.2063 10 14C10 11.7937 8.20625 10 6 10C3.79375 10 2 11.7937 2 14C2 16.2063 3.79375 18 6 18ZM34 18C36.2062 18 38 16.2063 38 14C38 11.7937 36.2062 10 34 10C31.7938 10 30 11.7937 30 14C30 16.2063 31.7938 18 34 18ZM36 20H32C30.9 20 29.9062 20.4438 29.1812 21.1625C31.7 22.5438 33.4875 25.0375 33.875 28H38C39.1063 28 40 27.1063 40 26V24C40 21.7937 38.2062 20 36 20ZM20 20C23.8687 20 27 16.8687 27 13C27 9.13125 23.8687 6 20 6C16.1313 6 13 9.13125 13 13C13 16.8687 16.1313 20 20 20ZM24.8 22H24.2812C22.9813 22.625 21.5375 23 20 23C18.4625 23 17.025 22.625 15.7188 22H15.2C11.225 22 8 25.225 8 29.2V31C8 32.6562 9.34375 34 11 34H29C30.6562 34 32 32.6562 32 31V29.2C32 25.225 28.775 22 24.8 22ZM10.8188 21.1625C10.0938 20.4438 9.1 20 8 20H4C1.79375 20 0 21.7937 0 24V26C0 27.1063 0.89375 28 2 28H6.11875C6.5125 25.0375 8.3 22.5438 10.8188 21.1625Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.0e205e93d472ab3fdf26e937c514cecd.svg";
export { ForwardRef as ReactComponent };